import React, { Component } from "react";

import { withLocalizer } from "utilities/withLocalizer";
import commonUtilities from "utilities/common";
import "./groupDetails.css";

class GroupDetails extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            languageCode: this.props.languageCode ?? commonUtilities.getLanguage()
        };
    }

    localize = (code) => {
        return this.props.localizeByLang(code, this.state.languageCode);
    };

    render() {

        const { group, groupTypes } = this.props;
        const selectedLang = this.state.languageCode;

        const groupType = commonUtilities.getGroupTypeName(selectedLang, group?.groupType, groupTypes);

        if (group) {

            const { groupName, noOfTravellers, eventName } = group;
            return (
                <div className="group-information-container">
                    <div className="row margin-bottom">
                        <strong>
                            {this.localize("qma-group-details")}
                        </strong>
                    </div>
                    <div className="row">
                        <div className="heading">
                            {this.localize("qma-group-name")}
                        </div>
                        <div className="value text-ellipsis">
                            {groupName}
                        </div>
                    </div>
                    <div className="row">
                        <div className="heading">
                            {this.localize("qma-group-type")}
                        </div>
                        <div className="value">
                            {groupType}
                        </div>
                    </div>
                    {eventName && (
                        <div className="row">
                            <div className="heading">
                                {this.localize("qma-event-type")}
                            </div>
                            <div className="value">
                                {eventName}
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="heading">
                            {this.localize("qma-travellers")}
                        </div>
                        <div className="value">
                            {noOfTravellers}
                        </div>
                    </div>
                </div>
            );

        }

    }
}

export default withLocalizer(GroupDetails);